module.exports = __webpack_public_path__ + "img/mantenimiento.1137d703.jpg";